var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-card",class:_vm.customClass},[(_vm.$slots.header)?[_vm._t("header"),_c('van-divider')]:_vm._e(),_vm._t("default"),(_vm.$slots.footer)?[_c('van-divider'),_vm._t("footer")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }